import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthDataStore } from '../auth-data/auth-data.store';
import { NavigationService } from '../navigation/navigation.service';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class AuthForwardGuard implements CanActivate {
  constructor(
    private _authDataStore: AuthDataStore,
    private _navigationService: NavigationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.checkAuthenticated(state.url).pipe(map((_) => !_));
  }

  checkAuthenticated(url: string): Observable<boolean> {
    return this._authDataStore.isAuthenticated().pipe(
      tap((authenticated: boolean) => {
        if (authenticated) {
          this._navigationService.goTo([url], { replaceUrl: true });
        }
      })
    );
  }
}
